import { GetStaticProps } from "next";
import loadNamespaces from "next-translate/loadNamespaces";
import useTranslation from "next-translate/useTranslation";
import React, { ReactElement } from "react";
import TemplateError from "faqSrc/components/templates/error";
import { pagesPath } from "faqSrc/lib/$path";

const Custom404 = (): ReactElement => {
  const { t } = useTranslation();
  return (
    <TemplateError
      message={t("frontPage:error.404.message")}
      title={t("frontPage:error.404.title")}
    />
  );
};

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  return {
    props: {
      ...(await loadNamespaces({
        locale,
        pathname: pagesPath.$404.$url().pathname,
      })),
    },
  };
};

export default Custom404;
